import { render } from "./ResultProjectType.vue?vue&type=template&id=dab75f36&scoped=true&ts=true"
import script from "./ResultProjectType.ts?vue&type=script&lang=ts"
export * from "./ResultProjectType.ts?vue&type=script&lang=ts"

import "./ResultProjectType.scss?vue&type=style&index=0&id=dab75f36&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dab75f36"]])

export default __exports__